import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import store from "./store"
import App from './App';
import './app/assets/globals.css';
import './app/assets/typography.css';
import "bootstrap-daterangepicker/daterangepicker.css";
//import './app/assets/skeleton-loader.css';
import './app/assets/root.scss';
import "rc-slider/assets/index.css";
import './app/assets/login.css';
import './app/assets/global.css';
//import './app/assets/moderation.css';
import './app/assets/display-parts.css';
import './app/assets/ugc-rights.css';
import './app/assets/card-style.css';
import './app/assets/analytics.css';
import './app/assets/uppy.bundle.css';
import "./app/assets/studio/studio.css";
import "./app/assets/studio/countdown.css";

import './app/assets/scss/root.scss';

import './App.css';
import 'lity/dist/lity.min.js'
import 'lity/dist/lity.min.css'
import { CookiesProvider } from "react-cookie";
import { iniFrame, setTokenFromWebsiteCookie } from "./utils";

const { PUBLIC_URL } = process.env;

const inIframe = iniFrame();

// coming from the website: move the session_token cookie into access_token, then reload
if (!inIframe && setTokenFromWebsiteCookie()) {
  window.location.reload();
} else {
  const root = ReactDOM.createRoot(document.getElementById('root-editor'));
  root.render(!inIframe ? <CookiesProvider><App basename={PUBLIC_URL} store={store} /></CookiesProvider> : <></>);
}